import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import * as PIXI from 'pixi.js';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import CreatePageConstants from '../../../../CreatePageConstants';
import { VISUALIZER_SHAPE } from '../../../../Preview/PreviewDisplayConstants';
import VisualizerLogoGlowTypeListItem from './VisualizerLogoGlowTypeListItem';
import VisualizerLogoGlowBlurListItem from './VisualizerLogoGlowBlurListItem';
import VisualizerLogoGlowScaleListItem from './VisualizerLogoGlowScaleListItem';

const VisualizerLogoGlowListItem = (props) => {
    const { logoGlowEnabled, visualizerShape, updateVisualizerSettings } = props;

    const onEnabledChange = (value) => updateVisualizerSettings({
        logoGlowSettings: { enabled: value }
    });

    // Logo Glow is not applicable to the flat visualizer shape.
    if (visualizerShape === VISUALIZER_SHAPE.FLAT)
        return null;

    return (
        <CollapsibleSwitchListItem
            checked={logoGlowEnabled}
            text='Logo Glow'
            onChange={onEnabledChange}
            warning={PIXI.utils.isWebGLSupported() ? null : CreatePageConstants.LIMITED_VISIBILITY_WARNING_TEXT}
        >
            <List dense disablePadding>
                <VisualizerLogoGlowTypeListItem />

                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <VisualizerLogoGlowBlurListItem />
                        },
                        {
                            width: 6,
                            component: <VisualizerLogoGlowScaleListItem />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { logoGlowSettings, shape: visualizerShape } = state.createPreview.present.videoSettings.visualizer;
    return {
        logoGlowEnabled: Boolean((logoGlowSettings || {}).enabled),
        visualizerShape
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerLogoGlowListItem);
